export default class Environment {
	constructor() {
		this.logLevels = {};
	}
}